import "./LeadListsHeader.scss"

import { ContentSwitcher, Search } from "@skylead/component-library"
import React from "react"
import { Link } from "react-router-dom"

import { useGlobalTranslation } from "../../../utils/hook"
import Button, { ButtonVariant } from "../../atoms/Button"

export const LeadListsHeader = ({ searchValue = "", onSearchValueChange = () => {} }) => {
  const { tt } = useGlobalTranslation()
  const newListRoute = "/users/:userID/teams/:teamID/accounts/:accountID/create-new-list"

  const contentSwitcherItems = [
    {
      text: tt("lead-lists"),
      active: true,
      disabled: true,
    },
  ]

  const handleSearchValueChange = value => {
    onSearchValueChange(value)
  }

  return (
    <div className="lead-lists-header-wrapper">
      <ContentSwitcher items={contentSwitcherItems} />
      <div className="lead-lists-header-right-side-wrapper">
        <Search
          placeholder={tt("lead-lists-search")}
          value={searchValue}
          onChange={handleSearchValueChange}
        />
        <Link to={newListRoute}>
          <Button variant={ButtonVariant.PRIMARY} className="accordion-btn" icon="plus-20">
            {tt("new")}
          </Button>
        </Link>
      </div>
    </div>
  )
}
